import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const UserService = {
  getPagedResult(
    page,
    resultsPerPage,
    sortBy,
    isDescending,
    search,
    filters,
  ) {
    const queryString = ApiUtil.buildQueryStringForPaged(
      page,
      resultsPerPage,
      sortBy,
      isDescending,
      search,
      filters,
    );

    return Http.get(`/user-admins?${queryString}`);
  },
  getById(id) {
    return Http.get(`/user-admins/${id}`);
  },
  create(data) {
    return Http.post('/user-admins', data);
  },
  update(id, data) {
    return Http.put(`/user-admins/${id}`, data);
  },
  updateStatus(id, status) {
    return Http.put(`/user-admins/${id}/status`, { status });
  },
  delete(id) {
    return Http.delete(`/user-admins/${id}`);
  },
};

export default UserService;
